import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import MadeByBadge from "@/components/brand/MadeByBadge";

/** Public legal page — accessible without login. Sober long-form layout. */
export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#0A0A0A]" data-testid="terms-page">
      <header className="sticky top-0 z-10 bg-white border-b-[3px] border-[#0A0A0A] px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Link
            to="/login"
            className="w-9 h-9 border-hard-2 rounded-xl bg-white flex items-center justify-center press-btn shadow-hard-sm"
            data-testid="terms-back-btn"
            aria-label="Geri"
          >
            <ArrowLeft strokeWidth={3} className="w-4 h-4" />
          </Link>
          <div>
            <div className="text-[10px] uppercase font-black tracking-widest text-[#555]">Yasal</div>
            <div className="font-display text-2xl leading-tight">Kullanıcı Sözleşmesi</div>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto p-4 md:p-8">
        <article className="prose-yappo space-y-4 text-sm md:text-base leading-relaxed">
          <p className="text-xs text-[#555] font-bold">Son güncelleme: 7 Şubat 2026</p>

          <h2 className="font-display text-xl">1. Taraflar ve Kabul</h2>
          <p>
            Bu Kullanıcı Sözleşmesi, <b>Yappo</b> (yappo.chat üzerinden hizmet veren uygulama)
            ile Yappo hesabı oluşturan ve/veya hizmetten yararlanan gerçek kişi
            ({"\u201C"}Kullanıcı{"\u201D"}) arasında akdedilmiştir. Yappo{"\u2019"}ya kayıt olarak
            veya hizmeti kullanarak bu sözleşmenin ve ayrıca yayımlanan Gizlilik Politikası{"\u2019"}nın
            tamamını kabul etmiş sayılırsınız.
          </p>

          <h2 className="font-display text-xl">2. Hizmetin Tanımı</h2>
          <p>
            Yappo; birebir ve grup mesajlaşma, sesli/görüntülü arama, kısa video paylaşımı
            (Reels), atmosfer ve ruh hali tabanlı sohbet dünyaları, konum paylaşımı, arkadaşlık
            seviyeleri ve günlük görevler gibi özellikleri içeren bir sosyal mesajlaşma
            servisidir. Yeni özellikler eklenebilir veya mevcutlar değiştirilebilir.
          </p>

          <h2 className="font-display text-xl">3. Hesap ve Yaş Şartı</h2>
          <p>
            Yappo{"\u2019"}yu kullanmak için en az <b>13</b> yaşında olmanız gerekir; 18 yaş altındaysanız
            ebeveyn veya yasal vasi izniniz gereklidir. Hesap bilgilerinizin güvenliği
            sizin sorumluluğunuzdadır; şifrenizi kimseyle paylaşmayın. Hesabınızda gerçekleşen
            tüm faaliyetlerden siz sorumlusunuz.
          </p>

          <h2 className="font-display text-xl">4. Kullanıcı Davranış Kuralları</h2>
          <p>Yappo{"\u2019"}da aşağıdaki içerik/davranışlar <b>kesinlikle yasaktır</b>:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Yasa dışı, tehdit, taciz, nefret söylemi, ayrımcı, cinsel istismar içeren
                veya çocukları hedef alan her türlü içerik</li>
            <li>Kişisel verilerin sahibinin rızası dışında yayılması (doxxing)</li>
            <li>Sahte hesap oluşturma, başkasının kimliğine bürünme, kimlik avı (phishing)</li>
            <li>Spam, otomatik/bot mesajlaşma, ticari reklam, dolandırıcılık girişimleri</li>
            <li>Fikri mülkiyet haklarını ihlal eden içerik yayınlamak</li>
            <li>Uygulamanın normal işleyişini bozmaya yönelik teknik girişimler</li>
          </ul>
          <p>Bu kuralları ihlal eden hesaplar geçici veya kalıcı olarak askıya alınabilir.</p>

          <h2 className="font-display text-xl">5. Kullanıcı İçeriği</h2>
          <p>
            Paylaştığınız mesaj, medya, konum ve profil bilgilerinin fikri mülkiyeti size
            aittir. Yappo, hizmeti sunabilmek için içeriğinizi işlemek ve hedef alıcıya
            iletmek üzere sınırlı bir kullanım hakkı kazanır. Yappo, hukuka aykırı içeriği
            önceden bildirimde bulunmaksızın kaldırma hakkını saklı tutar.
          </p>

          <h2 className="font-display text-xl">6. Bildirimler</h2>
          <p>
            Hizmetin bir parçası olarak size mesaj bildirimi, arkadaşlık isteği bildirimi,
            görev hatırlatıcısı ve önemli hesap duyuruları gönderilebilir. Bildirimleri
            Ayarlar → Bildirimler menüsünden kısmen veya tamamen kapatabilirsiniz.
          </p>

          <h2 className="font-display text-xl">7. Hesabın Sonlandırılması</h2>
          <p>
            Hesabınızı istediğiniz zaman kapatabilirsiniz. Yappo; sözleşme ihlali, güvenlik
            veya yasal zorunluluk nedeniyle hesabınızı askıya alabilir veya kalıcı olarak
            silebilir. Silme sonrası mesajlarınız, arkadaşlıklarınız ve reels{"\u2019"}leriniz de
            kalıcı olarak silinir.
          </p>

          <h2 className="font-display text-xl">8. Sorumluluğun Sınırlandırılması</h2>
          <p>
            Yappo {"\u201C"}olduğu gibi{"\u201D"} sunulur; kesintisizlik veya hatasızlık garanti edilmez.
            Yürürlükteki hukuk çerçevesinde Yappo, dolaylı zararlardan sorumlu tutulamaz.
          </p>

          <h2 className="font-display text-xl">9. Değişiklikler</h2>
          <p>
            Bu sözleşme güncellenebilir. Önemli değişiklikler uygulama içi bildirim veya
            e-posta ile duyurulur. Değişiklik sonrası hizmeti kullanmaya devam etmeniz,
            güncellenmiş sözleşmeyi kabul ettiğiniz anlamına gelir.
          </p>

          <h2 className="font-display text-xl">10. İletişim</h2>
          <p>
            Sözleşme, gizlilik veya diğer talepleriniz için: <a href="mailto:destek@yappo.chat" className="underline font-bold">destek@yappo.chat</a>
          </p>

          <p className="text-xs text-[#555] mt-6">
            Ayrıca bkz. <Link to="/privacy" className="underline font-bold">Gizlilik Politikası</Link>.
          </p>
        </article>
        <div className="mt-8 flex justify-center pb-4">
          <MadeByBadge />
        </div>
      </main>
    </div>
  );
}
